import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';
import { getModalState } from 'automation-ui-canvas/selectors/menuBarSelectors';
import { SingleActionTestOption } from 'automation-ui-canvas/components/flow-header/menu-bar/menuOptions/viewOptions';
import { setModalStateById } from 'automation-ui-canvas/actions/MenuBarActions';
import { Map as ImmutableMap } from 'immutable';
import debounce from 'transmute/debounce';
import useIsTestingEnabled from 'automation-ui-canvas/components/panels/debugger-panel/useIsTestingEnabled';
import { jsx as _jsx } from "react/jsx-runtime";
const DEBOUNCE_MS = 300;
const getKey = ({
  actionTypeId,
  actionId
}) => `${actionId}-${actionTypeId}`;
const useSingleActionTest = ({
  actionTypeId,
  actionId,
  flow
}) => {
  const dispatch = useDispatch();
  const isTestingEnabled = useIsTestingEnabled({
    actionTypeId,
    flow
  });
  const modalState = useSelector(getModalState).get(SingleActionTestOption.id) || ImmutableMap();
  const stagedAction = modalState.getIn([getKey({
    actionTypeId,
    actionId
  }), 'stagedAction']);
  const onResetTest = useCallback(() => {
    dispatch(setModalStateById({
      menuOptionId: SingleActionTestOption.id,
      modalState: modalState.setIn([getKey({
        actionTypeId,
        actionId
      }), 'hasUntestedChanges'], false)
    }));
  }, [dispatch, modalState, actionId, actionTypeId]);
  const onUpdateAction = useMemo(() => debounce(DEBOUNCE_MS, action => {
    dispatch(setModalStateById({
      menuOptionId: SingleActionTestOption.id,
      modalState: modalState.setIn([getKey({
        actionTypeId,
        actionId
      })], ImmutableMap({
        stagedAction: action,
        hasUntestedChanges: !!action //Clearing out the action will also clear the hasUntestedChanges
      }))
    }));
  }), [dispatch, modalState, actionId, actionTypeId]);
  return {
    stagedAction,
    isTestingEnabled,
    onUpdateAction,
    hasUntestedChanges: modalState.getIn([getKey({
      actionTypeId,
      actionId
    }), 'hasUntestedChanges']),
    onResetTest
  };
};
export const wireUseSingleActionTest = Component => {
  return props => {
    var _props$flow, _props$flow2;
    const actionTypeId = (_props$flow = props.flow) === null || _props$flow === void 0 || (_props$flow = _props$flow.getActions().get(parseInt(props.actionId, 10))) === null || _props$flow === void 0 ? void 0 : _props$flow.getActionTypeId();
    const {
      isTestingEnabled,
      stagedAction
    } = useSingleActionTest({
      actionTypeId,
      actionId: props.actionId,
      flow: (_props$flow2 = props.flow) === null || _props$flow2 === void 0 ? void 0 : _props$flow2.toHybridFlowInterface()
    });
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      isTestingEnabled: isTestingEnabled,
      stagedAction: stagedAction
    }));
  };
};
export default useSingleActionTest;